/**
 * Loader / Entry-Point des Widerruf-Widgets.
 *
 * Zwei Betriebsarten:
 *  A) Script-Tag (standalone/CDN): Konfiguration aus den data-* des <script>.
 *       <script src="…/widget/v1/loader.js" data-key="…" data-endpoint="…"
 *               data-cdn="…" data-position="left|right"
 *               data-primary-color data-button-text-color data-text-color
 *               data-accent-color data-font defer></script>
 *  B) Globale Config (z. B. WordPress): window.WiderrufToolConfig = {key, endpoint,
 *       cdn?, footer?, position?, branding:{primary,btn_text,text,accent,font}}.
 *
 * Mount-Ziele:
 *  - jedes [data-widerruf-button]  -> Trigger-Button (Modal), inline an dieser Stelle
 *  - jedes [data-widerruf-form]    -> Formular INLINE (kein Modal) – Shortcode/Block
 *  - sonst (footer): schwebender Footer-Button
 * Pro Element koennen data-color/-position/-button-text-color/-text-color/-accent-color/-font
 * die Defaults ueberschreiben. Branding gilt konsistent fuer Button UND Formular.
 *
 * No-AVV: data-endpoint zeigt auf die MAKLER-Komponente. Verbraucherdaten
 * erreichen unseren Endpoint technisch nie.
 */

import { WiderrufWidget } from "./widget.js";

(function () {
  "use strict";

  function qsa(sel) {
    return Array.prototype.slice.call(document.querySelectorAll(sel));
  }

  function currentScript() {
    if (document.currentScript) return document.currentScript;
    var s = document.querySelectorAll("script[data-key][data-endpoint]");
    for (var i = s.length - 1; i >= 0; i--) {
      if (/loader(\.min)?\.js/.test(s[i].src)) return s[i];
    }
    return s[s.length - 1] || null;
  }

  function fromScript(self) {
    return {
      key: self.getAttribute("data-key"),
      endpoint: self.getAttribute("data-endpoint"),
      cdn: self.getAttribute("data-cdn") || null,
      footer: true, // standalone: schwebender Button, wenn keine Ziel-Elemente
      position: self.getAttribute("data-position") || "left",
      branding: {
        primary: self.getAttribute("data-primary-color"),
        btn_text: self.getAttribute("data-button-text-color"),
        text: self.getAttribute("data-text-color"),
        accent: self.getAttribute("data-accent-color"),
        font: self.getAttribute("data-font"),
      },
    };
  }

  function overridesFor(el, cfg) {
    var d = (el && el.dataset) || {};
    var b = cfg.branding || {};
    return {
      position: d.position || cfg.position || "left",
      primary: d.color || d.primaryColor || b.primary || null,
      btn_text: d.buttonTextColor || b.btn_text || null,
      text: d.textColor || b.text || null,
      accent: d.accentColor || b.accent || null,
      font: d.font || b.font || null,
    };
  }

  function mountOne(cfg, el, inlineForm) {
    var w = new WiderrufWidget({
      key: cfg.key,
      endpoint: cfg.endpoint,
      cdn: cfg.cdn || null,
      overrides: overridesFor(el, cfg),
      mountTarget: el || null,
      inlineForm: !!inlineForm,
    });
    w.mount();
    return w;
  }

  function boot() {
    var self = currentScript();
    var cfg =
      window.WiderrufToolConfig && window.WiderrufToolConfig.key
        ? window.WiderrufToolConfig
        : self
        ? fromScript(self)
        : null;

    if (!cfg || !cfg.key || !cfg.endpoint) {
      if (window.console) {
        console.error("[widerruf] data-key/data-endpoint bzw. window.WiderrufToolConfig fehlt.");
      }
      return;
    }

    var buttons = qsa("[data-widerruf-button]");
    var forms = qsa("[data-widerruf-form]");
    var first = null;

    buttons.forEach(function (el) {
      var w = mountOne(cfg, el, false);
      first = first || w;
    });
    forms.forEach(function (el) {
      var w = mountOne(cfg, el, true);
      first = first || w;
    });

    // Footer-/Standalone-Fallback: schwebender Button, wenn keine Elemente da sind.
    if (cfg.footer && buttons.length === 0 && forms.length === 0) {
      first = mountOne(cfg, null, false) || first;
    }

    if (first) window.__widerrufWidget = first;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
